import config from '../config/app-config';
import eventLib from '@/libs/eventLib';
setTimeout(function () {
    eventLib.emit('initAppConfig', config);
});


// WEBPACK FOOTER //
// ./src/config.js